<template>
  <el-dialog
      title="获取退货地址时机"
      :visible.sync="visible"
      center
      width="600px"
      :loading="loading"
      @close="handlerCancel"
  >

    <el-form ref="form" :model="form" label-width="180px"	v-loading="loading" class="sync-return-form">
      <el-form-item label="获取时间">
        <el-radio-group v-model="form.sync_return_address_type">
          <el-radio :label="10" size="large">发货后24小时</el-radio>
          <el-radio :label="20" size="large">签收后</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="快递拦截或订单退款">
        <el-radio-group v-model="form.repurchase_type">
          <el-radio :label="10" size="large">自动重拍</el-radio>
          <el-radio :label="20" size="large">手动重拍</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="售后申请次数">
        <el-radio-group v-model="form.sync_return_address_refund_apply_num">
          <el-radio :label="1" size="large">1次</el-radio>
          <el-radio :label="2" size="large">2次</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handlerCancel">取 消</el-button>
      <el-button type="primary" @click="handlerConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
export default {
  data() {
    return {
      visible: false,
      form:{
        sync_return_address_type: 10,
        repurchase_type: 10,
        sync_return_address_refund_apply_num: 1,
      },
      loading: false
    }
  },
  mounted() {

  },
  methods: {
		...mapActions({
			opBusinessSetSyncReturnAddressType:"ucenter_order/opBusinessSetSyncReturnAddressType",
			getUserinfoData:"ucenter_order/getUserinfoData"
		}),
    open(){
      this.loading = true;
      this.getUserinfoData({
        data:{},
        success:(res)=>{
          console.log(res)
          this.form.sync_return_address_type = res.data.sync_return_address_type;
          this.form.repurchase_type = res.data.repurchase_type;
          this.form.sync_return_address_refund_apply_num = res.data.sync_return_address_refund_apply_num;
          this.loading = false;
        },
      })
      this.visible = true;
    },
    handlerConfirm(){
      this.opBusinessSetSyncReturnAddressType({
        data:this.form,
        success:(res)=>{
          this.$message.success(res.msg);
          this.visible = false;
        },
      })
    },
    handlerCancel(){
      this.visible = false;
    },
  }
}
</script>

<style scoped>
.sync-return-form{
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}
.sync-return-form >>> .el-form-item{
  margin-bottom: 8px;
}
.sync-return-form >>> .el-form-item:last-child{
  margin-bottom: 0;
}
.el-input-group--append .el-input__inner{
  text-align: center;
}
</style>
